<template>
    <div class="data-section">
        <div class="data-section__row">
            <ModelAutoComplete
                label="Гражданство"
                v-model="appendix.citizenship"
                :vizKeyPath="[['value']]"
                :items="autoCompleteCountry"
                @debounce-end="getAutocompleteCountry"
            />
        </div>
    </div>
</template>

<script>
import ModelAutoComplete from '@/components/UI/models/ModelAutoComplete';
import { post, qs } from '@/tools/http';

export default {
    name: 'WideAppendixData',
    props: {
        appendix: Object,
    },
    data: () => ({
        autoCompleteCountry: null,
    }),
    methods: {
        async getAutocompleteCountry(inputObj) {
            if (inputObj.value === '') {
                this.autoCompleteCountry = null;
                return;
            }
            let postParams = [
                'dadata',
                'search',
                qs({ query: inputObj.value, type: 'country' }),
                true,
                { 'content-type': 'application/x-www-form-urlencoded' },
            ];
            let res = await post(...postParams);
            this.autoCompleteCountry = res.suggestions;
        },
    },
    model: {
        prop: 'appendix',
        event: 'change',
    },
    components: {
        ModelAutoComplete,
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/account-data.scss';
</style>
